
// import './jquery-min-3.6.0';
import './mobile-menu';
import './mobile-menu-toggle';
import './video-player';
import './clients';
import './counters';
import './slideshow';
// import './parallax-elements';
import './map-locations';
import './features-grid';
import './accordion';
import './download-link';
import './toolkit';
import './search';
import './resource-download';
import './feature-header'; 
import './landing-page-header'; 

import './dynamic-pop-form-loader';

import './hris-switcher';
import './new-landing-page'; 

import './block-group-slide-show';
import './jquery-code';  
 
document.addEventListener('DOMContentLoaded', () => {
  var timelineElements = document.querySelectorAll(
    'ul.timeline ul li:nth-child(odd)'
  );

  if (timelineElements.length) {
    function adjust_timeline() {
      Array.from(timelineElements).forEach(function (element) {
        var remain =
          element.clientWidth - element.querySelector('a').clientWidth;
        element.style.backgroundPositionX = remain / 2 - 9 + 'px';
      });
    }

    adjust_timeline();
    window.addEventListener('resize', adjust_timeline);
  }

  var timelineAnchors = document.querySelectorAll('ul.timeline a');
  if (timelineAnchors.length) {
    Array.from(timelineAnchors).forEach(function (element) {
      element.dataset.title = element.innerText;

      if (element.href.slice(-1) === '#') {
        element.classList.add('timeline-coming-soon');
        element.addEventListener('click', function (e) {
          e.preventDefault();
        });
      }

      element.addEventListener('mouseenter', function () {
        if (element.href.slice(-1) === '#') {
          element.innerText = 'Coming soon';
        } else {
          element.innerText = 'Learn more';
        }
      });
      element.addEventListener('mouseleave', function () {
        element.innerText = element.dataset.title;
      });
    });
  }
});